import React from 'react';
import Heading from '../../../../Heading';
const ModalHeading = ({ className, size = 'large', ...restProps }) => (React.createElement(Heading, { ...restProps, size: size, className: className }));
ModalHeading.propTypes = Heading.propTypes;
export default ModalHeading;
//# sourceMappingURL=ModalHeading.js.map